export default {
  message: {
    title: '',
    preferVisitRead: '',
    preferVisitListten: '',
    preferVisitComplete: 'Completa',
    preferVisitShort: 'Curta',
    preferVisitSignoguia: 'Signoguia',
    titleVisitType: 'Visites guiades',
    titleMenu: 'Menú',
    moreInfo:'Saber-ne més?',
    moreInfoNo: 'No',
    moreInfoYes:'Sí',
    downloadAudio: '(Descàrrega d\'àudios)',
    download: 'Descàrrega dels arxius',
    downloadVideo: '(Descàrrega de videos)',
    downloadSignoguia: 'Descàrrega dels arxius de video',
    errorDownload: 'Hi ha hagut un error en la descàrrega. Torna a intentar-ho',
    cancelDownload: 'Has canceldo la descarga.',
    retry: 'Reintentar',
    noConnection: 'No tines conexión a internet',
    titleMap: 'SELECTEER EEN NUMMER',
    map: 'mapa.png',

    initDownload: 'Even geduld a.u.b.',
    endDownload: 'Audiotracks gedownload. Geniet van uw bezoek!',


    menuItems: [
        {
            img: '1.jpg',
            imageMenu: '',
            title: '1. OP WEG NAAR DE INGANG',
            author: '',
            description: '',
            audio: '1.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '2.jpg',
            imageMenu: '',
            title: '2. DE FOYER',
            author: '',
            description: '',
            audio: '2.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '2a.jpg',
                    second: '0'
                },
                {
                    img: '2b.jpg',
                    second: '26'
                },
                {
                    img: '2c.jpg',
                    second: '56'
                },
                {
                    img: '2d.jpg',
                    second: '89'
                },
            ],
        },
        {
            img: '3.jpg',
            imageMenu: '',
            title: '3. DE BALKONS ',
            author: '',
            description: '',
            audio: '3.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '3a.jpg',
                    second: '0'
                },
                {
                    img: '3b.jpg',
                    second: '38'
                },
                {
                    img: '3c.jpg',
                    second: '47'
                },
            ],
        },
        {
            img: '4.jpg',
            imageMenu: '',
            title: '4. VALENCIA EN MUZIEK ',
            author: '',
            description: '',
            audio: '4.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '4a.jpg',
                    second: '0'
                },
                {
                    img: '4b.jpg',
                    second: '28'
                },
                {
                    img: '4c.jpg',
                    second: '37'
                },
                {
                    img: '4d.jpg',
                    second: '41'
                },
                {
                    img: '4e.jpg',
                    second: '51'
                },
                {
                    img: '4f.jpg',
                    second: '112'
                },
                {
                    img: '4g.jpg',
                    second: '132'
                },
            ],
        },
        {
            img: '5.jpg',
            imageMenu: '',
            title: '5. INSTRUCTIES ',
            author: '',
            description: '',
            audio: '5.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '6.jpg',
            imageMenu: '',
            title: '6. VOET VAN DE TRAP',
            author: '',
            description: '',
            audio: '6.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '7.jpg',
            imageMenu: '',
            title: '7. DE OPENING',
            author: '',
            description: '',
            audio: '7.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '8.jpg',
            imageMenu: '',
            title: '8. DE GROTE ZAAL',
            author: '',
            description: '',
            audio: '8.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '8a.jpg',
                    second: '0'
                },
                {
                    img: '8b.jpg',
                    second: '110'
                },
                {
                    img: '8c.jpg',
                    second: '130'
                },
                {
                    img: '8d.jpg',
                    second: '135'
                },
                {
                    img: '8a.jpg',
                    second: '211'
                },
            ],
        },
        {
            img: '9.jpg',
            imageMenu: '',
            title: '9. EEN GOED BEGIN...',
            author: '',
            description: '',
            audio: '9.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '9a.jpg',
                    second: '0'
                },
                {
                    img: '9b.jpg',
                    second: '27'
                },
                {
                    img: '9c.jpg',
                    second: '67'
                },
                {
                    img: '9d.jpg',
                    second: '157'
                },
                {
                    img: '9e.jpg',
                    second: '175'
                }
            ]
        },
        {
            img: '10.jpg',
            imageMenu: '',
            title: '10. VAN A TOT Z',
            author: '',
            description: '',
            audio: '10.mp3',
            video: '',
            visitType: '{all}',

        },
        {
            img: '11.jpg',
            imageMenu: '',
            title: '11. ACHTER DE SCHERMEN',
            author: '',
            description: '',
            audio: '11.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '11a.jpg',
                    second: '0'
                },
                {
                    img: '11b.jpg',
                    second: '29'
                },
                {
                    img: '11c.jpg',
                    second: '46'
                },
                {
                    img: '11d.jpg',
                    second: '67'
                },
                {
                    img: '11e.jpg',
                    second: '88'
                },
                {
                    img: '11f.jpg',
                    second: '104'
                },
                {
                    img: '11g.jpg',
                    second: '120'
                },
                {
                    img: '11h.jpg',
                    second: '128'
                },
                {
                    img: '11i.jpg',
                    second: '160'
                },
                {
                    img: '11j.jpg',
                    second: '192'
                }
            ]
        },
        {
            img: '12.jpg',
            imageMenu: '',
            title: '12. INTERMEZZO 1',
            author: '',
            description: '',
            audio: '12.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '13.jpg',
            imageMenu: '',
            title: '13. DE STAD VAN CALATRAVA',
            author: '',
            description: '',
            audio: '13.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '13a.jpg',
                    second: '0'
                },
                {
                    img: '13b.jpg',
                    second: '66'
                },
                {
                    img: '13c.jpg',
                    second: '184'
                }
            ]
        },
        {
            img: '14.jpg',
            imageMenu: '',
            title: '14. OP WEG NAAR DE LIFT',
            author: '',
            description: '',
            audio: '14.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '15.jpg',
            imageMenu: '',
            title: '15. TERRAS',
            author: '',
            description: '',
            audio: '15.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '16.jpg',
            imageMenu: '',
            title: '16. KUNST',
            author: '',
            description: '',
            audio: '16.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '17.jpg',
            imageMenu: '',
            title: '17. AUDITORIUM',
            author: '',
            description: '',
            audio: '17.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '17a.jpg',
                    second: '0'
                },
                {
                    img: '17b.jpg',
                    second: '76'
                }
            ]
        },
        {
            img: '18.jpg',
            imageMenu: '',
            title: '18. INTERMEZZO 2',
            author: '',
            description: '',
            audio: '18.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '19.jpg',
            imageMenu: '',
            title: '19. TOT SNEL!',
            author: '',
            description: '',
            audio: '19.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '20.jpg',
            imageMenu: '',
            title: 'Créditos',
            author: '',
            description: 'Guion, producción, diseño y programación: Trama Media.<br><br>Agradecimientos: Palau de Les Arts Reina Sofía.<br><br>Todas las fotografías de las producciones de Les Arts y de la Ciudad de las Artes y las Ciencias han sido cedidas por Les Arts (©Mikel Ponce, ©Miguel Lorenzo, ©Tato Baeza). Otras: Álbum.<br><br>Todas las grabaciones en directo han sido cedidas por Les Arts.<br><br>1. Mascagni, Pietro. Ah! Lo vedi. <i>Cavalleria rusticana.</i> Director: Jordi Bernàcer. Intérpretes: Sonia Ganassi, Jorge de León.<br>4. Martín y Soler, Vicente. Obertura. <i>L’arbore di Diana.</i> Director: Rubén Dubrovsky.<br>7. Bizet, Georges. Obertura. <i>Carmen.</i> Director: Lorin Maazel.<br>8. Wagner, Richard. Hojotoho! Hojotoho! <i>La valquiria.</i> Director: Zubin Mehta. Intérprete: Jennifer Wilson.<br>9. Mascagni, Pietro. Intermezzo. <i>Cavalleria rusticana.</i> Director: Lorin Maazel.<br>10. Berlioz, Hector. Villanelle. <i>Les nuits d’été.</i> Director: Antonello Manacorda. Intérprete: Marianne Crebassa.<br>12. Leoncavallo, Ruggero. Vesti la giubba. <i>Pagliacci.</i> Director: Jordi Bernàcer. Intérprete: Jorge de León.<br>18. Prokófiev, Serguéi. Danza de los caballeros. Suite nº 2 de <i>Romeo y Julieta.</i> Director: James Gaffigan.<br>19. Massenet, Jules. Obéissons quan leur voix appelle. <i>Manon.</i> Director: James Gaffigan. Intérpretes: Lisette Oropesa y Coro de la Generalitat Valenciana dirigido por Francesc Perales.<br><br>Trama Media ha hecho todo lo posible por obtener las autorizaciones necesarias para todos los contenidos reproducidos en esta guía. No obstante, si desea formular alguna reclamación relativa a la propiedad intelectual, no dude en ponerse en contacto con nosotros.<br><br>Todos los derechos reservados.<br><br>',
            audio: '',
            visitType: '{all}',
            moreInfoItem: '',
            isCredits: true,

        }
    ]
  },
}



// WEBPACK FOOTER //
// ./src/data/i18n/nederlands.js